<div class="d-flex icon" [inlineSVG]="icon"></div>
